import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../assets/img/default-profile.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-comments" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-danger navbar-badge" }, "4", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "media" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "User Avatar",
      class: "img-size-50 mr-3 img-circle"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "dropdown-item-title" }, [
        /*#__PURE__*/_createTextVNode(" Brad Diesel "),
        /*#__PURE__*/_createElementVNode("span", { class: "float-right text-sm text-danger" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Call me whenever you can..."),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }),
        /*#__PURE__*/_createTextVNode(" 4 Hours Ago ")
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "media" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "User Avatar",
      class: "img-size-50 img-circle mr-3"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "dropdown-item-title" }, [
        /*#__PURE__*/_createTextVNode(" John Pierce "),
        /*#__PURE__*/_createElementVNode("span", { class: "float-right text-sm text-muted" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "I got your message bro"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }),
        /*#__PURE__*/_createTextVNode(" 4 Hours Ago ")
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "media" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "User Avatar",
      class: "img-size-50 img-circle mr-3"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "media-body" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "dropdown-item-title" }, [
        /*#__PURE__*/_createTextVNode(" Nora Silvester "),
        /*#__PURE__*/_createElementVNode("span", { class: "float-right text-sm text-warning" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "The subject goes here"),
      /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-muted" }, [
        /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock mr-1" }),
        /*#__PURE__*/_createTextVNode(" 4 Hours Ago ")
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-item dropdown-footer"
}, "See All Messages", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_dropdown = _resolveComponent("app-dropdown")!

  return (_openBlock(), _createBlock(_component_app_dropdown, { size: "lg" }, {
    "dropdown-button": _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    "dropdown-menu": _withCtx(() => [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9
    ]),
    _: 1
  }))
}